
import { Component, OnInit } from '@angular/core';
import { NotificationService, ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';
import { MeasuringFactorDto, MeasureDto } from '@cradua/data';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { Observable } from 'rxjs';
import { measuringfactorreducer } from './../../../../../gateway/src/lib/states/+gateway/gateway.reducer';

@Component({
  selector: 'cradua-measuring-factor-container',
  templateUrl: './measuring-factor-container.component.html',
  styleUrls: ['./measuring-factor-container.component.scss']
})
export class MeasuringFactorContainerComponent implements OnInit {

  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  measures$: Observable<MeasureDto[]>;
  measuringfactors$: Observable<MeasuringFactorDto[]>;
  loading: boolean;
  isLoadingMeasure$: Observable<boolean>;
  isLoadingMeasuringFactor$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
    private notificationService: NotificationService
  ) {}

  ngOnInit() {
    this.isLoadingMeasure$ = this.gatwayFacade.isLoadingGateway("Measure");
    this.isLoadingMeasuringFactor$ = this.gatwayFacade.isLoadingGateway("MeasuringFactor");

    this.measures$ = this.gatwayFacade.loadGateway("Measure");
    this.measuringfactors$ = this.gatwayFacade.loadGateway("MeasuringFactor");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteMeasuringFactor(deletedValue: any) {
    this.gatwayFacade.remove("MeasuringFactor", deletedValue);
  }

// this method control both the create and update
  onSubmitMeasuringFactor(formValue: any) {
    console.log('pull', formValue);
    const pullData = formValue.MeasuringFactors;
    console.log('pull', pullData);

// declare two empty array to hold update and create data
  const allUpdates = [] ;
  const addAllMeasuringFactor = [];

// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id) {
      allUpdates.push(pullData[i]);
    } else {
      addAllMeasuringFactor.push(pullData[i]);
    }
  }

// check if the addAllMeasuringFactor array is not empty, then dispatch the data to the store
   if(addAllMeasuringFactor.length > 0) {
    this.gatwayFacade.add('MeasuringFactor', addAllMeasuringFactor);
   }

// dispatch update data to the store
   if(allUpdates.length > 0) {
    this.gatwayFacade.update('MeasuringFactor', allUpdates, ['id']);
   }
  }


}
